import infoTemplate from './views/info/template.html';
import infoController from './views/info';
import addonsTemplate from './views/addons/template.html';
import addonsController from './views/addons';
import materialsTemplate from './views/materials/template.html';
import materialsController from './views/materials';
import invitationsTemplate from './views/invitations/template.html';
import invitationsController from './views/invitations';
import registrationsTemplate from './views/registrations/template.html';
import registrationsController from './views/registrations';
import certificatesTemplate from './views/certificates/template.html';
import certificatesController from './views/certificates';
import evaluationsTemplate from './views/evaluations/template.html';
import evaluationsController from './views/evaluations';
import reportsTemplate from './views/reports/template.html';
import reportsController from './views/reports';
import baseView from './views/base';
import emailTemplatesTemplate from './views/emailTemplates/get/template.html';
import emailTemplatesIdTemplate from './views/emailTemplates/edit/template.html';
import emailTemplatesController from './views/emailTemplates';

const eventsEventBase = {
  url: '/:eventid',
  stateName: 'Course Event',
  abstract: true,
  resolve: {
    eventData: /* @ngInject */ (ApiClass, $stateParams) =>
      $stateParams.eventid && $stateParams.eventid !== 'new'
        ? ApiClass.eventsIdGet(
            { id: $stateParams.eventid },
            {},
            { queryParams: { manage: true, 'joins:outlook': true, 'joins:webinar': $stateParams.reload === 'true' } }
          )
        : false,
    courseData: /* @ngInject */ (ApiClass, $stateParams) =>
      $stateParams.courseid && $stateParams.courseid !== 'new'
        ? ApiClass.coursesIdGet({ id: $stateParams.courseid }, {}, { queryParams: { manage: true } })
        : false
  },
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': baseView
  }
};

const eventsEventAddons = {
  url: '/add-ons',
  stateName: 'Add-Ons',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/event-manager/:id/add-ons')
  },
  views: {
    a: {
      controller: addonsController,
      controllerAs: 'eventAddOnsCtrl',
      template: addonsTemplate
    }
  }
};

const eventsEventOverview = {
  url: '/event-info',
  stateName: 'Event Info',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/event-manager/:id/event-info')
  },
  views: {
    a: {
      template: infoTemplate,
      controller: infoController,
      controllerAs: 'infoCtrl'
    }
  }
};

const eventsEventEmailTemplatesState = {
  url: '/emails',
  stateName: 'Email Templates',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/event-manager/:id/emails')
  },
  views: {
    a: {
      template: emailTemplatesTemplate,
      controller: emailTemplatesController,
      controllerAs: 'emailTemplatesCtrl'
    }
  }
};

const eventsEventEmailTemplatesIdState = {
  url: '/:type_id',
  stateName: 'Email Template Edit',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app.eventManager.course.event': {
      template: emailTemplatesIdTemplate,
      controller: emailTemplatesController,
      controllerAs: 'emailTemplatesCtrl'
    }
  }
};

const eventsEventMaterials = {
  url: '/materials',
  stateName: 'Event Materials',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/event-manager/:id/materials')
  },
  views: {
    a: {
      template: materialsTemplate,
      controller: materialsController,
      controllerAs: 'materialCtrl'
    }
  }
};

const eventsEventInvitations = {
  url: '/invitations?location',
  stateName: 'Event Invitations',
  reloadOnSearch: false,
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: invitationsTemplate,
      controller: invitationsController,
      controllerAs: 'invitationsCtrl'
    }
  }
};

const eventsEventRegistrations = {
  url: '/registrations?location',
  stateName: 'Event Registrations',
  reloadOnSearch: false,
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: registrationsTemplate,
      controller: registrationsController,
      controllerAs: 'registrationsCtrl'
    }
  }
};

const eventsEventCertificates = {
  url: '/certificates?location',
  stateName: 'Event Certificates',
  reloadOnSearch: false,
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: certificatesTemplate,
      controller: certificatesController,
      controllerAs: 'eventCertsCtrl'
    }
  }
};

const eventsEventEvaluations = {
  url: '/evaluations',
  stateName: 'Event Evaluations',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/event-manager/:id/evaluations')
  },
  views: {
    a: {
      template: evaluationsTemplate,
      controller: evaluationsController,
      controllerAs: 'eventEvalCtrl'
    }
  }
};

const eventsEventReports = {
  url: '/Reports',
  stateName: 'Event Reports',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: reportsTemplate,
      controller: reportsController,
      controllerAs: 'reportsCtrl'
    }
  }
};

export {
  eventsEventBase,
  eventsEventOverview,
  eventsEventAddons,
  eventsEventMaterials,
  eventsEventInvitations,
  eventsEventRegistrations,
  eventsEventCertificates,
  eventsEventEvaluations,
  eventsEventReports,
  eventsEventEmailTemplatesState,
  eventsEventEmailTemplatesIdState
};



// WEBPACK FOOTER //
// ./src/app/controllers/admin/events/event/index.js